<script lang="ts" setup>
interface Props {
  active: boolean
}

defineProps<Props>()
</script>

<template>
  <ElementsButton
    class="btn-nav flex min-w-[200px] items-center justify-between gap-4 !px-4"
  >
    <span class="mx-auto text-center text-xs uppercase">
      <slot />
    </span>

    <Icon
      mode="svg"
      name="fa6-solid:chevron-down"
      class="text-2xl transition-transform"
      :class="{ 'rotate-180': active }"
    />
  </ElementsButton>
</template>

<style lang="scss" scoped>
.btn-nav * {
  pointer-events: none;
}
</style>
